/**
 *
 * Asynchronously loads the component for MapPage
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index').then(mod => mod.default || mod),
  loading: () => null,
});
